import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChatBubble7: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChatBubble7"><Path d="M12 2.5C17.483 2.5 22 6.71457 22 12C22 17.2854 17.483 21.5 12 21.5C10.3287 21.5 8.75042 21.1094 7.3623 20.418C6.22533 20.7199 5.05598 20.9073 3.82422 20.9834L2.66016 21.0557L3.07715 19.9668C3.39464 19.1387 3.66028 18.3207 3.83984 17.4922C2.68365 15.9443 2 14.0489 2 12C2 6.71457 6.51697 2.5 12 2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChatBubble7;
